import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";

const ENDPOINTS = {
  stats: "/admin/stats", lists: "/admin/lists", tables: "/admin/tables", payments: "/admin/payments",
  events: "/events", users: "/admin/users", scouting: "/admin/scouting-links",
  clicks: "/admin/list-clicks", folders: "/media/folders",
};

export default function useAdminData(enabled) {
  const [data, setData] = useState({ stats: null, lists: [], tables: [], payments: [], events: [], users: [], scouting: [], clicks: [], folders: [] });
  const load = useCallback(async () => {
    const keys = Object.keys(ENDPOINTS);
    const res = await Promise.all(keys.map(k => api.get(ENDPOINTS[k])));
    setData(Object.fromEntries(keys.map((k, i) => [k, res[i].data])));
  }, []);
  useEffect(() => { if (enabled) { load(); } }, [enabled, load]);
  return { ...data, load };
}
